import useTranslation from '~/client/hooks/i18n/useTranslation';

type Topic = SelectOption & { sites: Site[] };

const useTopics = (): Topic[] => [
  {
    value: 'deposits',
    label: useTranslation('support.deposits'),
    sites: ['bitcasino', 'livecasino', 'empire'],
  },
  {
    value: 'withdrawals',
    label: useTranslation('support.withdrawals'),
    sites: ['bitcasino', 'livecasino', 'empire'],
  },
  {
    value: 'bitcoin information',
    label: useTranslation('support.bitcoin_information'),
    sites: ['bitcasino', 'livecasino', 'empire'],
  },
  {
    value: 'bonus questions',
    label: useTranslation('support.bonus_questions'),
    sites: ['bitcasino', 'livecasino', 'empire'],
  },
  {
    value: 'game issue',
    label: useTranslation('support.game_issue'),
    sites: ['bitcasino', 'livecasino', 'empire'],
  },
  {
    value: 'bet question',
    label: useTranslation('support.bet_question'),
    sites: ['bitcasino', 'livecasino', 'empire'],
  },
  {
    value: 'promotional or raffle question',
    label: useTranslation('support.promotional_or_raffle_question'),
    sites: ['bitcasino', 'livecasino', 'empire'],
  },
  {
    value: 'terms and conditions',
    label: useTranslation('support.terms_and_conditions'),
    sites: ['bitcasino', 'livecasino', 'empire'],
  },
  {
    value: 'vip program question',
    label: useTranslation('support.vip_program_question'),
    sites: ['bitcasino'],
  },
  {
    value: 'affiliate question',
    label: useTranslation('support.affiliate_question'),
    sites: ['bitcasino', 'livecasino', 'empire'],
  },
  {
    value: 'account settings question',
    label: useTranslation('support.account_settings_question'),
    sites: ['bitcasino', 'livecasino', 'empire'],
  },
  {
    value: 'account security question',
    label: useTranslation('support.account_security_question'),
    sites: ['bitcasino', 'livecasino', 'empire'],
  },
];

export default useTopics;
